// Initialize Mixpanel
import mixpanel from 'mixpanel-browser';
import { getAppVersion } from '@/utils/app-version';
import { getCurrentConference, getLatestConferenceType } from '@/utils/conference-type';

let initialized = false;

export const initMixPanel = () => {
  const token = process.env.VUE_APP_MIXPANEL_API_TOKEN;
  if (!token) {
    console.warn('[Mixpanel] VUE_APP_MIXPANEL_API_TOKEN is not set — skipping init');
    return;
  }
  mixpanel.init(token, {
    api_host: 'https://api-eu.mixpanel.com',
    autocapture: {
      capture_extra_attrs: ['data-event-tracking'],
    },
    ip: true,
    track_pageview: true,
    persistence: 'localStorage',
    record_sessions_percent: 100,
    record_heatmap_data: true,
    record_block_selector: '',
    record_mask_text_selector: '',
  });
  initialized = true;
  console.log('[Mixpanel] initialized with token:', token.slice(0, 6) + '...');

  getAppVersion()
    .then(version => {
      mixpanel.register({ app_version: version });
    })
    .catch(() => {
      /* register skipped if version unavailable */
    });
};

export const startMixPanel = async (
  delegateId,
  email,
  name,
  organization,
  groupName,
  conferences,
) => {
  if (!initialized) return;
  const appVersion = await getAppVersion();
  mixpanel.identify(delegateId);
  const peopleProps = {
    $name: name,
    $church: organization,
    $team: groupName,
    $email: email,
    // Same live conference as delegateType below — getCurrentConference picks one
    // deterministically when several are flagged current, so the two can't disagree.
    year: getCurrentConference(conferences)?.year,
    userType: organization === 'Heart of God Church' ? 'Host' : 'Delegate',
    delegateType: getLatestConferenceType(conferences),
    app_version: appVersion,
  };
  mixpanel.people.set(peopleProps);
  console.log('[Mixpanel] startMixPanel - identified:', delegateId, peopleProps);

  // To restart the session, use anonymize
};

export const trackEvent = (eventName, properties = {}) => {
  if (!initialized) return;
  try {
    mixpanel.track(eventName, properties);
    console.log('[Mixpanel] trackEvent:', eventName, properties);
  } catch (e) {
    console.error('[Mixpanel] trackEvent failed:', eventName, e);
  }
};

export const setMixpanelUserProperty = (properties = {}) => {
  if (!initialized) return;
  try {
    mixpanel.people.set(properties);
    console.log('[Mixpanel] setUserProperty:', properties);
  } catch (e) {
    console.error('[Mixpanel] setUserProperty failed:', properties, e);
  }
};

// Export mixpanel for use in other modules
export default mixpanel;
